module.exports = __webpack_public_path__ + "3412ab87d8ec73265c1b6590abc4c9ab.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/wk-bike.svg
// module id = 954
// module chunks = 0